import {Gender} from "../enums/gender.enum";

class GenericConstants {
    public static Genders = [
        Gender.Male,
        Gender.Female,
        Gender.NonBinary,
        Gender.GenderFluid,
        Gender.Undisclosed
    ];
    
    public static DefaultLoadingResultsDelay = 3000;
    
    public static PreventDuplicateAnswerCategories: Record<string, string[]> = {
        "Love Languages": ["Love Language #1", "Love Language #2", "Love Language #3"]
    };
}

export { GenericConstants };